import * as z from "zod/v4";

export const ReturnsOverTimeDataPointSchema = z.object({
  date: z.string(),
  count: z.number(),
});

export type ReturnsOverTimeDataPoint = z.infer<
  typeof ReturnsOverTimeDataPointSchema
>;

export const getReturnsProcessingOverTime = {
  name: "getReturnsProcessingOverTime" as const,
  input: z.object({
    startDate: z.coerce.date(),
    endDate: z.coerce.date(),
    grain: z.enum(["daily", "weekly", "monthly"]),
    merchantTimezone: z.string().optional(),
    merchantTeamId: z.string().optional(),
  }),
  output: z.object({ data: z.array(ReturnsOverTimeDataPointSchema) }),
};
